import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import {finalize} from 'rxjs';

import {clientDetailsQuery} from '@store/clients/details';
import {clientsUnitsQuery, clientsUnitsService} from '@store/clients/units';
import {GlobalStatus} from '@store/common/globalStatus.enum';

import {Add, Download, GroupAction} from '@icons/index';

import TabsComponent from '@components/tabs/Tabs.component';
import ClientUnitsTable from '@screens/admin/clients/details/clientUnits/ClientUnits.table';

const ClientUnitsTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(clientsUnitsQuery.status$);
  const [selectedClientUnits] = useObservable(clientsUnitsQuery.selectedClientsUnits$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsUnitsService.getClientsUnitsCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} mt="10px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <TabsComponent
          ariaLabel="secondary"
          handleChange={(value) => clientsUnitsService.setStatus(GlobalStatus.tabs[value])}
          value={GlobalStatus.tabs.indexOf(filterStatus ?? undefined)}
          tabs={[t('routes.all'), t('routes.archived')]}/>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>
        </Stack>
      </Stack>
      <ClientUnitsTable/>
    </Stack>
  );
};

export default ClientUnitsTab;
